import HorizontalSeparator from 'app/components/common/HorizontalSeparator/HorizontalSeparator';
import {
  Button,
  Col,
  Grid,
  MenuItem,
  InputLabel,
  Input,
  OutlinedInput,
  Box,
  Chip,
  Checkbox,
  ListItemText,
  Modal
} from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';
import { TextField } from '../../components/common/TextField';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../_metronic/_partials/controls';
import React, { useState, useEffect } from 'react';
import MultipleSelect from 'app/components/common/MultipleSelect/MultipleSelect';
import { Autocomplete } from '@material-ui/lab';
import DiseaseModel from '../../models/Disease';
import SymptomModel from '../../models/Symptom';
import generalInfoModel from '../../models/GeneralInformation';
import Select from 'react-select';
import { Row } from 'react-bootstrap';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import _, { isInteger } from 'lodash';
import DiseaseSymptomSelectionModal from './DiseaseSymptomSelectionModal';
const DiseaseEditPageV2 = () => {
  const { id } = useParams();

  const [animalOptions, setAnimalOptions] = useState([]);
  //const [bodyPartOptions, setBodyPartOptions] = useState([]);
  const [temperatureOptions, setTemperatureOptions] = useState([]);
  const [drinkingOptions, setDrinkingOptions] = useState([]);
  const [eatingOptions, setEatingOptions] = useState([]);
  const [foodTypeOptions, setFoodTypeOptions] = useState([]);
  const [generalConditionOptions, setGeneralConditionOptions] = useState([]);
  const [symptomOptions, setSymptomOptions] = useState([]);

  const [selectedName, setSelectedName] = useState('');
  const [selectedAnimal, setSelectedAnimal] = useState(null);
  const [selectedDescription, setSelectedDescription] = useState('');
  const [selectedAction, setSelectedAction] = useState('');
  const [selectedBodyPart, setSelectedBodyPart] = useState([]);
  const [selectedTemperature, setSelectedTemperature] = useState(null);
  const [selectedDrinking, setSelectedDrinking] = useState(null);
  const [selectedEating, setSelectedEating] = useState(null);
  const [selectedFood, setSelectedFood] = useState(null);
  const [selectedGeneralCondition, setSelectedGeneralCondition] = useState(null);
  const [selectedSymptoms, setSelectedSymptoms] = useState([]);
  const [modalData, setModalData] = useState(null);

  const [oldSymptomDiseaseID, setOldSymptomDiseaseID] = useState([]);

  const [symptomDetailToEdit, setSymptomDetailToEdit] = useState(null);

  // const [tmpSymptom, setTmpSymptom] = useState([]);

  /* const handleChangeMultiple = event => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setPersonName(value);
  }; */

  /* let animalOptions = [
    {
      value: 'Dog',
      label: 'Dog'
    },
    {
      value: 'Cat',
      label: 'Cat'
    },
    {
      value: 'Rabbit',
      label: 'Rabbit'
    }
  ]; */

  /* let bodyPartOptions = [
    {
      value: 'Mouth',
      label: 'Mouth'
    },
    {
      value: 'Nose',
      label: 'Nose'
    },
    {
      value: 'Stomach',
      label: 'Stomach'
    },
    {
      value: 'Fur',
      label: 'Fur'
    },
    {
      value: 'Leg',
      label: 'Leg'
    }
  ]; */

  /* let temperatureOptions = [
    {
      value: '>38',
      label: 'Over 38 Celcius'
    },
    {
      value: '36-38',
      label: 'Between 36-38 Celcius'
    },
    {
      value: '<36',
      label: 'Below 36 Celcius'
    }
  ]; */

  /* let drinkingOptions = [
    {
      value: 'Very Little',
      label: 'Very Little'
    },
    {
      value: 'Little',
      label: 'Little'
    },
    {
      value: 'Normal',
      label: 'Normal'
    },
    {
      value: 'Much',
      label: 'Much'
    },
    {
      value: 'Too Much',
      label: 'Too Much'
    } 
  ]; */

  /* let eatingOptions = [
    {
      value: '1x',
      label: '1x'
    },
    {
      value: '2x',
      label: '2x'
    },
    {
      value: '3x',
      label: '3x'
    },
    {
      value: '>5x',
      label: '>5x'
    }
  ]; */

  /* let foodTypeOptions = [
    {
      value: 'Raw food',
      label: 'Raw food'
    },
    {
      value: 'Canned food',
      label: 'Canned food'
    },
    {
      value: 'Liquid',
      label: 'Liquid'
    }
  ]; */

  const getDiseaseData = async () => {
    try {
      let Disease = new DiseaseModel();
      let diseaseInfo = await Disease.getDiseaseById(id);
      console.log('abc', diseaseInfo);

      setSelectedName(diseaseInfo.name);
      setSelectedAnimal({ label: diseaseInfo.animal_type.animal_name, value: diseaseInfo.animal_type.id });
      setSelectedDescription(diseaseInfo.description)
      setSelectedAction(diseaseInfo.action);

      let generalInformations = diseaseInfo.disease_general_information;

      setSelectedDrinking(
        generalInformations
          .filter(el => el.generalinformation.category == 'drinking')
          .map(el => {
            return { label: el.generalinformation.value, value: el.generalinformation.id };
          })
      );
      //console.log("minum", drinking)
      setSelectedTemperature(
        generalInformations
          .filter(el => el.generalinformation.category == 'body_temperature')
          .map(el => {
            return { label: el.generalinformation.value, value: el.generalinformation.id };
          })
      );

      setSelectedEating(
        generalInformations
          .filter(el => el.generalinformation.category == 'eating')
          .map(el => {
            return { label: el.generalinformation.value, value: el.generalinformation.id };
          })
      );

      setSelectedFood(
        generalInformations
          .filter(el => el.generalinformation.category == 'food_type')
          .map(el => {
            return { label: el.generalinformation.value, value: el.generalinformation.id };
          })
      );

      setSelectedGeneralCondition(
        generalInformations
          .filter(el => el.generalinformation.category == 'general_condition')
          .map(el => {
            return { label: el.generalinformation.value, value: el.generalinformation.id };
          })
      );

      let resultSymptom = await SymptomModel.getAll();
      let oldSymptomDiseases = []
      let uniqueSymptoms = _.keys(
        _.countBy(diseaseInfo.symptoms_disease, data => {
          return data.symptom_id;
        })
      );
      let symptomsArray = [];
      uniqueSymptoms.forEach(el => {
        console.log('LOLOL', el);
        let filteredSymptomDisease = diseaseInfo.symptoms_disease.filter(el2 => el2.symptom_id == el);
        let newSymptom = filteredSymptomDisease[0].symptoms;
        let sd;
        let name;
        let tempDetail = [];
        let unique = [];
        
        filteredSymptomDisease.forEach(element => {
          if (!unique.includes(element.symptom_detail_options.symptoms_detail.detail_name)) {
            unique.push(element.symptom_detail_options.symptoms_detail.detail_name);
          }
        });
        //console.log("mencoba", filteredSymptomDisease)

        unique.forEach(dn => {
          let detail = filteredSymptomDisease
            .filter(el3 => el3.symptom_detail_options.symptoms_detail.detail_name == dn)
            .map((el3, idx) => {
              console.log('WAKACIPAW', el3, filteredSymptomDisease);
              if (!oldSymptomDiseases.includes(el3.id)) {
                oldSymptomDiseases.push(el3.id);
              }
              //if (idx == 0) name = filteredSymptomDisease[idx].symptom_detail_options.symptoms_detail.detail_name;
              let symptom = resultSymptom.filter(res => res.id == el3.symptom_id);
              console.log(symptom, 'PPPP');
              sd = symptom[0].symptoms_detail.map((el, idx) => {
                console.log('awooga', el);
                let a = {
                  detail_name: el.detail_name,
                  options: el.symptom_detail_options.map(sy => ({
                    symptom_id: symptom[0].id,
                    label: sy.options,
                    symptom_detail_option_id: sy.id,
                    value: sy.id
                  }))
                };
                console.log('apa', a);

                /* let b = {
                name: el.detail_name,
                options: el.symptom_detail_options.map(sy => {
                  console.log("syA", sy)
                return({
                  symptom_id: resultSymptom.id,
                  label: sy.options,
                  symptom_detail_option_id: sy.id,
                  value: sy.id
                })})
              } 
              return a; */
                return a;
              });

              /////////////////////////
              /* let uniqueDetails = _.keys(_.countBy(el3, (data => {
              console.log(data, el3, 'datak')
              return data.symptom_detail_options?.symptoms_detail_id})))
            console.log(uniqueDetails, "LLLLL") */

              /////////////////////////
              return {
                id: el3.id,
                symptom_id: el3.symptom_id,
                label: el3.symptom_detail_options.options,
                symptom_detail_option_id: el3.symptom_detail_options_id,
                value: el3.symptom_detail_options_id
              };
            });

          tempDetail.push({ name: dn, options: [...detail] });
        });

        console.log(filteredSymptomDisease, 'POPOPOP', newSymptom);
        symptomsArray.push({ ...newSymptom, detail: tempDetail, symptoms_detail: sd });
      });
      console.log('WKKK', uniqueSymptoms, diseaseInfo.symptoms_disease, symptomsArray);
      console.log('USMP', diseaseInfo, resultSymptom, symptomsArray);
      setOldSymptomDiseaseID(oldSymptomDiseases)
      setSelectedSymptoms(symptomsArray);
    } catch (e) {
      console.log(e);
    }
  };

  console.log('SYTO', symptomOptions, selectedSymptoms);

  const initializeGeneralInfo = async () => {
    try {
      let result = await generalInfoModel.getAll();
      let resultSymptom = await SymptomModel.getAllActive();

      console.log('awoo', resultSymptom);
      console.log(result);

      setSymptomOptions(resultSymptom);

      const uniqueGenInfo = [...new Set(result.generalinformation.map(item => item.category))];
      console.log(uniqueGenInfo);

      setTemperatureOptions(
        result.generalinformation
          .filter(el => el.category == 'body_temperature')
          .map(a => ({
            value: a.id,
            label: a.value
          }))
      );
      console.log(drinkingOptions);

      setDrinkingOptions(
        result.generalinformation
          .filter(el => el.category == 'drinking')
          .map(a => ({
            value: a.id,
            label: a.value
          }))
      );
      console.log(drinkingOptions);

      setFoodTypeOptions(
        result.generalinformation
          .filter(el => el.category == 'food_type')
          .map(a => ({
            value: a.id,
            label: a.value
          }))
      );
      console.log(foodTypeOptions);

      setEatingOptions(
        result.generalinformation
          .filter(el => el.category == 'eating')
          .map(a => ({
            value: a.id,
            label: a.value
          }))
      );
      console.log(eatingOptions);

      setGeneralConditionOptions(
        result.generalinformation
          .filter(el => el.category == 'general_condition')
          .map(a => ({
            value: a.id,
            label: a.value
          }))
      );
      console.log(generalConditionOptions);

      setAnimalOptions(
        result.animal_types.map(a => ({
          value: a.id,
          label: a.animal_name
        }))
      );
      console.log(result.animal_types);
      /* let tempDrink = result.generalInformation.drinking.map((a) => ({
          value: a.value,
          label: a.value
      }))
      setDrinkingOptions(tempDrink)

      let tempFood = result.generalInformation.food_type.map((a) => ({
        value: a.value,
        label: a.value
      }))
      setFoodTypeOptions(tempFood)

      let tempEating = result.generalInformation.eating.map((a) => ({
        value: a.value,
        label: a.value
      }))
      setEatingOptions(tempEating)

      let tempTemperature = result.generalInformation.body_temperature.map((a) => ({
        value: a.value,
        label: a.value
      }))
      setTemperatureOptions(tempTemperature)

      let tempGeneral = result.generalInformation.general_condition.map((a) => ({
        value: a.value,
        label: a.value
      }))
      setGeneralConditionOptions(tempGeneral) */
    } catch (e) {
      console.log('error', e);
    }
  };

  const submit = async () => {
    //console.log(selectedSymptoms);
    if (selectedName == null || selectedName == '' || selectedName == []) {
      swal({
        title: 'Name',
        text: 'Name cannot be empty',
        icon: 'error'
      });
      return;
    }
    if (selectedAnimal == null || selectedAnimal == '' || selectedAnimal == []) {
      swal({
        title: 'Animal',
        text: 'Animal cannot be empty',
        icon: 'error'
      });
      return;
    }
    if (selectedAction == null || selectedAction == '' || selectedAction == []) {
      swal({
        title: 'Action',
        text: 'Action cannot be empty',
        icon: 'error'
      });
      return;
    }
    /* if (selectedTemperature == null || selectedTemperature == '' || selectedTemperature == []) {
      swal({
        title: 'Body Temperature',
        text: 'Body temperature cannot be empty',
        icon: 'error'
      });
      return;
    }
    if (selectedDrinking == null || selectedDrinking == '' || selectedDrinking == []) {
      swal({
        title: 'Drinking',
        text: 'Drinking cannot be empty',
        icon: 'error'
      });
      return;
    }
    if (selectedEating == null || selectedEating == '' || selectedEating == []) {
      swal({
        title: 'Food Frequency',
        text: 'Food frequency cannot be empty',
        icon: 'error'
      });
      return;
    }
    if (selectedFood == null || selectedFood == '' || selectedFood == []) {
      swal({
        title: 'Food Type',
        text: 'Food type cannot be empty',
        icon: 'error'
      });
      return;
    }
    if (selectedGeneralCondition == null || selectedGeneralCondition == '' || selectedGeneralCondition == []) {
      swal({
        title: 'General Condition',
        text: 'General condition cannot be empty',
        icon: 'error'
      });
      return;
    } */
    /* if (selectedSymptoms == null || selectedSymptoms == '' || selectedSymptoms == []) {
      swal({
        title: 'Symptom',
        text: 'Symptoms cannot be empty',
        icon: 'error'
      });
      return;
    } */

    let generalInfo = [];
    selectedDrinking?.forEach(element => {
      generalInfo.push(element.value);
    });
    selectedEating?.forEach(element => {
      generalInfo.push(element.value);
    });
    selectedFood?.forEach(element => {
      generalInfo.push(element.value);
    });
    selectedGeneralCondition?.forEach(element => {
      generalInfo.push(element.value);
    });
    selectedTemperature?.forEach(element => {
      generalInfo.push(element.value);
    });
    let body = {
      name: selectedName,
      description: selectedDescription,
      action: selectedAction,
      animal_type_id: selectedAnimal?.value,
      general_informations: generalInfo
    };
    //console.log(body, selectedSymptoms)
    let notDeleted = []
    let symArray = [];
    console.log('dikit lagi', selectedSymptoms);
    selectedSymptoms?.forEach(el => {
      el.detail?.forEach(det => {
        det.options?.forEach(opt => {
          if (!notDeleted.includes(opt.id) && isInteger(opt.id)) {
            notDeleted.push(opt.id);
          }
          symArray.push({ id: opt.id, symptom_id: opt.symptom_id, symptom_detail_options_id: opt.symptom_detail_option_id });
        });
      });
    });
    body.symptoms = symArray;

    console.log(notDeleted)

    let toBeDeleted = oldSymptomDiseaseID.filter(x => !notDeleted.includes(x));
    body.deleted = toBeDeleted

    console.log(body, 'BODY');

    try {
      let res = await DiseaseModel.edit(id, body);

      //console.log('rez', res);

      swal({
        title: 'Success',
        text: 'Disease has been updated',
        icon: 'success'
      }).then(() => reset);
    } catch (error) {
      swal({
        title: 'Error',
        text: 'Cannot update disease',
        icon: 'error'
      });
    }
  };

  const handleDelete = async e => {
    try {
      let Disease = new DiseaseModel();
      Swal.fire({
        title: 'Delete Disease',
        text: 'Are you sure you want to delete this disease?',
        icon: 'warning',
        showCancelButton: true,
        confirmButton: 'Yes',
        confirmButtonColor: '#0d6efd',
        cancelButton: 'Cancel',
        cancelButtonColor: '#d33'
        // dangerMode: true,
      }).then(async result => {
        if (result.isConfirmed) {
          try {
            let result = await Disease.deleteDiseaseById(id);

            if (result.id || result.success) {
              swal({
                title: 'Success',
                text: 'Delete Successful',
                icon: 'success'
              }).then(() => {
                window.location.href = `/disease/`;
              });
            } else {
              await swal.fire('Failed', 'Failed to delete', 'error');
            }
          } catch (e) {
            console.error(e);
            await swal.fire('', e.error_message ? e.error_message : 'Something Wrong', 'error');
          }
        }
      });
    } catch (e) {
      console.log(e);

      swal({
        title: 'Error',
        text: e.error_message ? e.error_message : 'An Error Occurred',
        icon: 'error',
        customClass: {
          container: 'swal-z'
        }
      });
    }
  };


  const reset = () => {
    setSelectedAction('');
    setSelectedAnimal(null);
    setSelectedDrinking(null);
    setSelectedEating(null);
    setSelectedFood(null);
    setSelectedGeneralCondition(null);
    setSelectedName('');
    setSelectedSymptoms(null);
    setSelectedTemperature(null);
  };

  useEffect(() => {
    initializeGeneralInfo();
    getDiseaseData(id);
  }, []);

  return (
    <>
      <Card>
        <CardHeader title="Disease details">
          <CardHeaderToolbar>
            <Button color={'secondary'} variant="contained" onClick={handleDelete}>
              Delete
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  // id="name"
                  value={selectedName}
                  onChange={e => setSelectedName(e.target.value)}
                  label="Disease Name *"
                  input={<OutlinedInput label="Tag" />}
                  // helperText={touched.name ? errors.name : ''}
                  // error={touched.name && errors.name ? true : false}
                />
              </Grid>
            </Grid>
            <HorizontalSeparator text={'Animal'} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <MultipleSelect
                  label={'Type'}
                  options={animalOptions}
                  selected={selectedAnimal}
                  setSelected={setSelectedAnimal}
                  isMulti={false}
                />
                {/* <Select
                  isMulti
                  name="animal"
                  options={animalOptions}
                  onChange={e => setSelectedAnimal(e.target.value)}
                  className="basic-multi-select"
                  classNamePrefix="select"
                /> */}
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <MultipleSelect
                  label={'Body Part associated with the disease'}
                  options={bodyPartOptions}
                  selected={selectedBodyPart}
                  setSelected={setSelectedBodyPart}
                />
              </Grid> */}
            </Grid>
            <HorizontalSeparator text={'Description'} />
            <TextField
              rows={6}
              fullWidth
              multiline
              variant="outlined"
              value={selectedDescription}
              onChange={e => setSelectedDescription(e.target.value)}
            />
            <HorizontalSeparator text={'Action'} />
            <TextField
              rows={6}
              fullWidth
              multiline
              variant="outlined"
              value={selectedAction}
              onChange={e => setSelectedAction(e.target.value)}
            />
            <HorizontalSeparator text={'General Information'} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <b>Body Temperature</b>
              </Grid>
              <Grid item xs={12} sm={6}>
                <MultipleSelect
                  options={temperatureOptions}
                  selected={selectedTemperature}
                  setSelected={setSelectedTemperature}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <b>Drinking</b>
              </Grid>
              <Grid item xs={12} sm={6}>
                <MultipleSelect
                  label={'Frequency (in a day)'}
                  options={drinkingOptions}
                  selected={selectedDrinking}
                  setSelected={setSelectedDrinking}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <b>Eating</b>
              </Grid>
              <Grid item xs={12} sm={6}>
                <MultipleSelect
                  label={'Frequency (in a day)'}
                  options={eatingOptions}
                  selected={selectedEating}
                  setSelected={setSelectedEating}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MultipleSelect
                  label={'Food type'}
                  options={foodTypeOptions}
                  selected={selectedFood}
                  setSelected={setSelectedFood}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <b>General Condition</b>
              </Grid>
              <Grid item xs={12} sm={12}>
                <MultipleSelect
                  label={''}
                  options={generalConditionOptions}
                  selected={selectedGeneralCondition}
                  setSelected={setSelectedGeneralCondition}
                />
              </Grid>
            </Grid>
            <HorizontalSeparator text={'Symptoms'} />
            <Autocomplete
              id="combo-box-demo"
              // options={symptomOptions ? : []}
              options={
                symptomOptions
                  ? symptomOptions?.filter(obj => {
                      for (let ss of selectedSymptoms) {
                        if (obj.id === ss.id) {
                          return false;
                        }
                      }
                      return true;
                    })
                  : []
              }
              getOptionLabel={option => option.name}
              style={{ width: 300 }}
              onChange={(event, value) => {
                let sd = value.symptoms_detail.map((el, idx) => {
                  console.log('ababa', value);
                  let a = {
                    detail_name: el.detail_name,
                    options: el.symptom_detail_options.map(sy => ({
                      symptom_id: value.id,
                      label: sy.options,
                      symptom_detail_option_id: sy.id,
                      value: sy.id
                    }))
                  };
                  return a;
                });
                value = { ...value, symptoms_detail: sd };
                console.log(value);
                setModalData(value);
              }}
              value={modalData}
              renderTags={selectedSymptoms => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    padding: '0rem'
                  }}
                >
                  {selectedSymptoms.map(el => (
                    <Chip
                      key={el.id}
                      label={el.name}
                      onMouseDown={event => {
                        event.stopPropagation();
                      }}
                      style={{
                        margin: 2,
                        marginTop: 0,
                        marginBottom: 0,
                        borderRadius: '0.25rem'
                      }}
                    />
                  ))}
                </div>
              )}
              renderInput={params => (
                <TextField {...params} label="Search symptoms, e.g. vomiting" variant="outlined" />
              )}
            />
            <Grid container style={{ marginTop: '0.75rem' }} spacing={2}>
              {selectedSymptoms?.map((el, idx) => {
                {
                  console.log(selectedSymptoms, 'abcdef');
                }
                return (
                  <Grid item md={3} sm={4} xs={12}>
                    <Card
                      onClick={() => {
                        console.log('MDD PARAM', el);
                        setSymptomDetailToEdit(el);
                      }}
                      style={{ backgroundColor: 'rgba(18, 18, 18, 0.24)', color: '#666', cursor: 'pointer' }}
                    >
                      <CardBody style={{ padding: '0.25rem 0.38rem 0.25rem 0.5rem' }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            cursor: 'pointer'
                          }}
                        >
                          <div>{el.name}</div>
                          <div
                            onClick={e => {
                              let temp = [...selectedSymptoms];
                              temp.splice(idx, 1);
                              setSelectedSymptoms(temp);
                              e.stopPropagation();
                            }}
                            style={{
                              color: 'white',
                              backgroundColor: 'rgba(18, 18, 18, 0.24)',
                              borderRadius: 999999,
                              width: '1rem',
                              height: '1rem',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              cursor: 'pointer'
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M3 9L9 3M3 3L9 9"
                                stroke="white"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <ul>
                          {el.detail
                            ?.filter(detailEl => detailEl.options != 'undefined' && detailEl.options != null)
                            .map((detailEl, idx2) => {
                              console.log(detailEl, 'WOI');
                              return (
                                <li>
                                  <span>
                                    {detailEl.name}:{' '}
                                    {detailEl.options?.map((optionEl, idx3) => {
                                      if (idx3 < detailEl.options.length - 1) return optionEl.label + ', ';
                                      else return optionEl.label;
                                    })}
                                  </span>
                                </li>
                              );
                            })}
                        </ul>
                      </CardBody>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </form>
          <br />
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            <Button color={'primary'} variant="contained" onClick={submit}>
              Save
            </Button>
          </div>
        </CardBody>
      </Card>

      <DiseaseSymptomSelectionModal
        modalData={modalData}
        onClose={() => setModalData(null)}
        onSubmit={tmpSymptom => {
          let tmp = selectedSymptoms ? [...selectedSymptoms] : [];
          let tmp2 = [...tmpSymptom];
          tmp2 = tmp2.map((el, idx) => ({ name: modalData?.symptoms_detail[idx]?.detail_name, options: el }));
          //console.log(tmp2, 'oi');
          tmp.push({ name: modalData.name, detail: tmp2, id: modalData.id, ...modalData });
          //console.log(tmp, 'oi');
          console.log('UPDATERESULTCREATE', tmp);
          setSelectedSymptoms(tmp);
        }}
      />

      <DiseaseSymptomSelectionModal
        modalData={symptomDetailToEdit}
        onClose={() => setSymptomDetailToEdit(null)}
        onSubmit={tmpSymptom => {
          let currentIndex = selectedSymptoms.findIndex(obj => obj.id === symptomDetailToEdit.id);
          let temp = [...selectedSymptoms];

          let tmp2 = [...tmpSymptom];
          tmp2 = tmp2.map((el, idx) => ({ name: symptomDetailToEdit?.symptoms_detail[idx]?.detail_name, options: el }));

          temp[currentIndex] = { ...temp[currentIndex], detail: tmp2 };
          console.log('UPDATERESULTUPDATE', temp);

          setSelectedSymptoms(temp);

          // let tmp = selectedSymptoms ? [...selectedSymptoms] : [];
          // let tmp2 = [...tmpSymptom];
          // tmp2 = tmp2.map((el, idx) => ({ name: modalData?.symptoms_detail[idx]?.detail_name, options: el }));
          // //console.log(tmp2, 'oi');
          // tmp.push({ name: modalData.name, detail: tmp2, id : modalData.id});
          // //console.log(tmp, 'oi');
          // setSelectedSymptoms(tmp);
        }}
      />
    </>
  );
};

export default DiseaseEditPageV2;
